import React from 'react';

const NotFound = () => {
    return (
        <div className='flex justify-center items-center my-3'>
            <img src="https://i.ibb.co/XktCcQJ/404-error.jpg" alt="notfound" />
        </div>
    );
};

export default NotFound;